export default {
  name: 'messageMobile',
  props: {
  },
  setup() {
    return {}
  },
}
